module.exports = __webpack_public_path__ + "static/media/tese_rebeca.75f052f7.png";